import clsx from "clsx";
import Logo from "components/Reusable/Logo";
import Button from "components/Elements/Button/Button";
import parse from "html-react-parser";

import { Dispatch, memo, SetStateAction } from "react";
import { useContent } from "contexts/contentContext/contentContext";
import type { AuthModalTypeT } from "../../models/models";
import { CustomDomainPagesE } from "models/enums";

import styles from "./signInOrgBanner.module.scss";

interface SignInOrgBannerI extends React.HTMLAttributes<HTMLDivElement> {
  setModalType: Dispatch<SetStateAction<AuthModalTypeT>>;
  topUserPageLink: string;
  orgName: string;
}

const isInviteByLinkPage = window.location.pathname.includes(
  CustomDomainPagesE.INVITE
);

const isInviteByEmailPage = window.location.pathname.includes(
  CustomDomainPagesE.SUB_USER_COMPLETE
);

const SignInOrgBanner = memo((props: SignInOrgBannerI) => {
  const { topUserPageLink, className, setModalType, orgName, ...restProps } =
    props;

  const { getTextByKey, getPath } = useContent();

  const handleNavigateToSignUp = () => {
    setModalType("join-org");
  };

  const topUserPageUrl = `https://${
    window.location.hostname
  }${getPath()}page/${topUserPageLink}`;

  console.log(topUserPageUrl, orgName);

  const subTitleText = parse(
    getTextByKey("invite-org-subtitle")
      .replace("#link#", topUserPageUrl)
      .replace("#orgName#", orgName)
  );

  return (
    <div className={clsx(styles.wrapper, className)} {...restProps}>
      <Logo className={styles.logoWrapper} replaceWhenOrgDomain />
      <p>{subTitleText}</p>
      {isInviteByLinkPage || isInviteByEmailPage ? (
        <Button
          onClick={handleNavigateToSignUp}
          className={styles.signUpButton}
        >
          {getTextByKey("signup")}
        </Button>
      ) : null}
    </div>
  );
});

export default SignInOrgBanner;
